var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSortNo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  viewBox: "0 0 16 16"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_24327",
  "data-name": "Group 24327",
  transform: "translate(20320 20163)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3114",
  "data-name": "Rectangle 3114",
  width: 16,
  height: 16,
  transform: "translate(-20320 -20163)",
  fill: "#fff",
  opacity: 0
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_24324",
  "data-name": "Group 24324",
  transform: "translate(-20321.039 -20164.336)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1397",
  "data-name": "Path 1397",
  d: "M15.52,19.224a.7.7,0,0,1-.5-.206L12.206,16.2a.7.7,0,0,1,1-1l2.318,2.318,2.318-2.318a.7.7,0,0,1,1,1l-2.816,2.816A.7.7,0,0,1,15.52,19.224Z",
  transform: "translate(-2.96 -3.552)",
  fill: "#a3a3a3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1398",
  "data-name": "Path 1398",
  d: "M16.7,15.672a.7.7,0,0,1-.7-.7V3.7a.7.7,0,0,1,1.408,0V14.968A.7.7,0,0,1,16.7,15.672Z",
  transform: "translate(-4.144 0)",
  fill: "#a3a3a3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1399",
  "data-name": "Path 1399",
  d: "M8.336,7.224a.7.7,0,0,1-.5-.206L5.52,4.7,3.2,7.018a.7.7,0,0,1-1-1L5.022,3.206a.7.7,0,0,1,1,0L8.834,6.022a.7.7,0,0,1-.5,1.2Z",
  transform: "translate(0 0)",
  fill: "#a3a3a3"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_1400",
  "data-name": "Path 1400",
  d: "M6.7,15.672a.7.7,0,0,1-.7-.7V3.7a.7.7,0,0,1,1.408,0V14.968A.7.7,0,0,1,6.7,15.672Z",
  transform: "translate(-1.184 0)",
  fill: "#a3a3a3"
})))));
export { SvgSortNo as ReactComponent };
export default __webpack_public_path__ + "static/media/sort-no.cb651a8a927cc5a79383b230f0313fe2.svg";